import React from 'react';
import { IconLabel } from '@landtrustinc/design-system';
import usePackageBadges from './hooks/usePackageBadges';

import css from './PackageBadges.module.css';

const PackageBadges = ({ packageInfo, overrideInfo, listing }) => {
  const badges = usePackageBadges(packageInfo, overrideInfo, listing);

  return (
    <div className={css.root}>
      {badges.map((badge, index) => (
        <IconLabel
          iconSize="medium"
          // eslint-disable-next-line react/no-array-index-key
          key={`${packageInfo.id}-badge-${index}`}
          label={badge.label}
          variant={badge.variant}
        />
      ))}
    </div>
  );
};

export default PackageBadges;
